import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";

const { Types, Creators } = createActions(
  {
    success: ["data"],
    reset: [],
  },
  { prefix: "FILTER_TRANSPORT_" }
);

export interface FilterTransportState {
  data: any | null;
}

interface SuccessFilterTransport {
  data: any;
}

const INITIAL_STATE: FilterTransportState = {
  data: null,
};

const success = (state: FilterTransportState, action: SuccessFilterTransport) =>
  update(state, {
    data: { $set: action.data },
  });

const reset = () => INITIAL_STATE;

export const filterTransport = createReducer(INITIAL_STATE, {
  [Types.SUCCESS]: success,
  [Types.RESET]: reset,
});

export const FilterTransportTypes = Types;
export const FilterTransportActions = Creators;
